import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";
import { getKindLabel } from "utils/select_options/product_kind_options";
import ChangeProductGroupModal from "./components/ChangeProductGroupModal";

const ProductGroup = ({ product_id, product_kind, product_group, refetch }) => {
  const [is_open_modal, setOpenModal] = useState(false);
  return (
    <Dashboard
      header={{
        title: "Podstawowe informacje",
        icon: "info",
        aside: (
          <Link
            className="btn btn-sm btn-blue"
            to={`/products_manage/product_groups/${product_group?.id}/specification/products/${product_id}`}
          >
            <span>Specyfikacja</span>
          </Link>
        ),
      }}
      footer={<Button text="Zmień" onClick={() => setOpenModal(true)} />}
    >
      {is_open_modal && (
        <ChangeProductGroupModal
          product_id={product_id}
          product_kind={product_kind}
          refetch={refetch}
          handleClose={() => setOpenModal(false)}
        />
      )}
      <div className="dashboard__form">
        <Input
          label="Produkt grupowy"
          input={{
            name: "root_taxon_id",
            disabled: true,
            value: `[${product_group?.sku}] ${product_group?.name}`,
          }}
          meta={{}}
        />
        <Input
          label="Rodzaj (niezmienny, dziedziczony z produktu grupowego)"
          input={{
            name: "kind",
            disabled: true,
            value: getKindLabel(product_kind),
          }}
          meta={{}}
        />
      </div>
    </Dashboard>
  );
};

export default ProductGroup;
